/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Members_Deactivated_OnInputs */



/**
* | output |
* | --- |
* | "Deactivated on {date}" |
*
* @param {Members_Deactivated_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_deactivated_on = /** @type {((inputs: Members_Deactivated_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Deactivated_OnInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Deaktiviert am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Deactivated on ${i?.date}`)
});